import type React from 'react';
import {
  Activity,
  Database,
  Folder,
  BarChart3,
  BookOpen,
  Bug,
  BugOff,
  BugPlay,
  Building2,
  Calendar,
  CalendarDays,
  CalendarRange,
  Clipboard,
  ClipboardCheck,
  ClipboardList,
  ClipboardPen,
  Clock,
  Contact,
  Layers,
  LayoutDashboard,
  Lightbulb,
  LogOut,
  Mail,
  Menu,
  MessageCircleQuestion,
  MessageSquareHeart,
  MessageSquareMore,
  Notebook,
  NotebookTabs,
  NotebookText,
  Pencil,
  Settings,
  Shield,
  Smartphone,
  User,
  UserCheck,
  UserCircle,
  UserCircle2,
  UserCog,
  Users,
  type LucideIcon,
  type LucideProps
} from 'lucide-react';
import DashboardIcon from './DashboardIcon';
import SeasonIcon from '../components/SeasonIcon';

export type IconType = LucideIcon | React.FC<LucideProps>;

export const AppIcons: Record<string, IconType> = {
  dashboard: DashboardIcon,
  webdav: Folder,
  database: Database,
  push_registrations: Smartphone,
  menu: Menu,
  settings: Settings,
  logout: LogOut,
  planning: CalendarDays,
  training_calendar: CalendarRange,
  training_exercises: Notebook,
  training_sessions: NotebookText,
  training_exercise_plans: NotebookTabs,
  lineup: ClipboardPen,
  schedule: ClipboardList,
  analysis: ClipboardCheck,
  team: Users,
  intake: MessageCircleQuestion,
  player_statistics: BarChart3,
  player_evaluations: UserCheck,
  admin_dashboard: LayoutDashboard,
  club_dashboard: LayoutDashboard,
  admin_emails: Mail,
  clubs: Building2,
  teams: Users,
  teams_management: Users,
  seasons: SeasonIcon,
  players: User,
  users: UserCog,
  contacts: Contact,
  user_management: UserCircle,
  formations: Layers,
  match_types: Calendar,
  matches: Calendar,
  security: Shield,
  live_matches: Activity,
  admin_email: Mail,
  training_plan_editor: Pencil,
  evaluations: Clipboard,
  club: Building2,
  evaluations_management: Clipboard,
  user_profile: UserCircle2,
  clock: Clock,
  support: MessageSquareHeart,
  forum: MessageSquareMore,
  knowledge_base: BookOpen,
  issue_resolved: BugOff,
  issue_open: Bug,
  issue_future: BugPlay,
  issue_label_bug: Bug,
  issue_label_question: MessageCircleQuestion,
  issue_label_enhancement: Lightbulb,
  issue_label_task: ClipboardCheck,
};

export type AppIconName = keyof typeof AppIcons;
